import React from "react";
import { useRecoilValue } from "recoil";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import PointHistory from "../../components/pages/Benefit/Point/PointHistory";
import PointTab, {
  pointTabState,
} from "../../components/pages/Benefit/Point/PointTab";
import ScheduledPoint from "../../components/pages/Benefit/Point/ScheduledPoint";

export default function PointManage() {
  const pointTab = useRecoilValue(pointTabState);

  return (
    <>
      <PageTitle title="포인트 관리" />

      <PointTab />

      {pointTab === 0 ? <PointHistory /> : <ScheduledPoint />}
    </>
  );
}
